import React from "react";
import { JWTAuth } from "jwt-usu";
import Cookies from "js-cookie";
import { appsUrl } from "../config/urls";
import axios from "../config/axios";
import LoadingPage from "../components/LoadingPage";
import { withRouter } from "react-router-dom";

const ssoAuth = (WrappedComponent, type = 1) => {
  class SSO extends React.Component {
    state = {
      loading: true,
      user: {},
    };

    constructor() {
      super();
      JWTAuth.communicate(
        "https://sso.usu.ac.id/auth/listen",
        Cookies.get("ssotok") //diubah belakangan
      )
        .then((response) => {
          if (!response.logged_in) {
            const ssoPage = JWTAuth.makeLink({
              baseUrl: "https://sso.usu.ac.id/auth/login",
              redir: type === 1 ? appsUrl + "/admin" : appsUrl, //diubah belakangan
              callback: null,
            });
            window.location = ssoPage;
          } else {
            axios
              .get(
                "/users/" +
                  (type === 1
                    ? response.payload.user_id
                    : "mahasiswa/" + response.payload.user_id)
              )
              .then(async (res) => {
                if (res.data) {
                  response.payload.info = res.data;
                  this.setState({ user: response.payload });
                  //   await localStorage.setItem('user', JSON.stringify(response.payload))
                } else {
                  this.props.history.push({
                    pathname: "/500",
                    state: {
                      errorMessage:
                        type === 2
                          ? "Data SIA tidak ditemukan atau bermasalah"
                          : "Data user tidak ditemukan di API",
                    },
                  });
                }
                this.setState({
                  loading: false,
                });
              })
              .catch((error) => {
                if (response.logged_in) {
                  if (type === 1) window.location.href = "/403";
                  else if (type === 2) window.location.href = "/admin";
                } else {
                  window.location.href = "/500";
                }
              });
          }
        })
        .catch((error) => {
          window.location.href = "/500";
        });
    }

    render() {
      return this.state.loading ? (
        <LoadingPage />
      ) : (
        <WrappedComponent {...this.props} user={this.state.user} />
      );
    }
  }

  return withRouter(SSO);
};

export default ssoAuth;
